import { typedHttpsCallableWrapper } from '../api-_utils';
import { API_ROUTE_CONFIG } from './api-config/config';

export class APIPatient {
  public static getPatient = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.patient.get.patient
  );

  public static getPatientImpactProfile = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.patient.impact.profile
  );

  public static getPatientProfile = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.patient.get.profile
  );

  public static getPatientLatestImpactTest = typedHttpsCallableWrapper(API_ROUTE_CONFIG.patient.impact.lastTest)
}
